<template>
    <span
        class="ro-type-tag"
        :style="{
            color: meta.color,
            backgroundColor: meta.bg,
            borderColor: meta.color ? `${meta.color}33` : 'transparent',
        }"
        :title="meta.approvalHint"
    >
        <i :class="meta.icon"></i>
        <span>{{ meta.label }}</span>
    </span>
</template>

<script>
import { ORDER_TYPE_META, orderTypeOf, TYPE_TUYEN_CHINH_THUC } from "@/core/config/recruitmentOrders/recruitmentOrdersOption";

export default {
    name: "OrderTypeTag",
    props: {
        /** Nhận object order, số type, hoặc chuỗi order_type */
        order: { type: [Object, String, Number], default: null },
    },
    computed: {
        meta() {
            const val = typeof this.order === "object" ? orderTypeOf(this.order) : (this.order || TYPE_TUYEN_CHINH_THUC);
            return ORDER_TYPE_META[val] || ORDER_TYPE_META[TYPE_TUYEN_CHINH_THUC];
        },
    },
};
</script>

<style scoped>
.ro-type-tag {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 999px;
    border: 1px solid transparent;
    white-space: nowrap;
    line-height: 1.2;
}
.ro-type-tag i {
    font-size: 12.5px;
}
</style>
